// extracted by mini-css-extract-plugin
export default {"meal-form":"MealItemForm_meal-form__5R6xH","error":"MealItemForm_error__UFAO1"};